module.exports = __webpack_public_path__ + "img/black38.678570bc.png";